//Testnet
import abibsc from "../Config/abibsc.json"; 
import Notarize from "../Config/Notarize.json";
import generator from  "../Config/generator.json";
// export const RPC_URL ="https://data-seed-prebsc-1-s1.binance.org:8545";


export const bsccontractaddress="0x2b6f3BC500AAaf5882dc84Fc0036827CCE45e208";
export const maticcontractaddress="0xDF9171ED0713077f5469367E00F951bb04F9aA3A";
export const ethcontractaddress ="0x21B8cE1C0b8218C87Ae4E1962ceD81b2D47b55Dd";
export const GenerateTokenmatic ="0x503f8EC9F2fCc71398828A82DC31e7b0c8720C87";
export const GenerateTokenbnb="";


export const Notarizematicaddress="0x1FBd3Eb6896AA354011A2708ac0Ad75BAC8709a4";
export const Notarizebscaddress='';
export const NotarizeETHaddress='';

export const ABI =abibsc;
// Notarize 
export const ABINotarize = Notarize;
export const TokenGeneratorABI=generator;
export const API_URL="https://myreview.website/enefti/API";
export const APP_URL ="https://myreview.website/enefti";

// export const API_URL="https://testnet.mintdaq.com/API";
// export const APP_URL ="https://testnet.mintdaq.com";

// Binanace
export const Bsc_Chainid = 97;
export const Bsc_Chainname = 'Binance';
export const Bsc_Chain_symbol = 'BNB';
export const Bsc_RPC_URL = 'https://data-seed-prebsc-1-s1.binance.org:8545/';
export const Bsc_block_explorer = 'https://testnet.bscscan.com/';

// matic
export const Matic_Chainid = 80001;
export const Matic_Chainname = 'Matic Testnet';
export const Matic_Chain_symbol = 'MATIC';
export const Matic_RPC_URL = 'https://rpc-mumbai.maticvigil.com/';
export const Matic_block_explorer = 'https://mumbai.polygonscan.com/';

// Ethereum 
export const ETH_Chainid = 5;
export const ETH_Chainname = 'Goerli test network';
export const ETH_Chain_symbol = 'GoerliETH';
export const ETH_RPC_URL = 'https://goerli.infura.io/v3/';
export const ETH_block_explorer = 'https://goerli.etherscan.io';